import Vue from 'vue'
import { getToken,getUserInfo} from '@/utils/auth'
import wxLogin from '@/api/user'
Vue.prototype.authorVerify = function (url,callback){
    // console.log(getUserInfo())
    console.log(getToken())
    // if(!getToken()){
        wxLogin('wxbca9a1aeb51664cb', url)
    // }else{
    //     callback()
    // }
  }


// WEBPACK FOOTER //
// ./src/author.js